import Swiper, {Autoplay, FreeMode, Mousewheel, Scrollbar} from 'swiper';

Swiper.use([Autoplay, FreeMode, Mousewheel, Scrollbar]);

export default function(element = '.js-swiper-cards') {
  return new Swiper(element, {
    slidesPerView: 'auto',
    grabCursor: true,
    direction: 'horizontal',
    edgeSwipeDetection: 'prevent',
    freeMode: {
      enabled: true,
      sticky: false,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
  });
}
